<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Purchase History</h4>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12 pt-0">
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="
                  qrCodeValues.find((x) => x[0] == r.order_id) ? 'background-color: #FFF9C4' : ''
                "
                class="table-tr"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td>{{ r.order_id }}</td>
                <td>{{ r.last_order_invoice }}</td>
                <td v-if="r.qrcode == null || r.qrcode == ''">{{ r.theOrderID }}</td>
                <td v-else><i
                  class="fa fa-qrcode"
                  aria-hidden="true"
                  ></i> {{ r.theOrderID }}</td>
                <td>{{ r.customer_id_fk }}</td>
                <td class="ws-nowrap">
                  <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i>
                  <i v-else class="material-icons customer-device-icon">language</i>
                  <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.phone_number }}</td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td v-if="r.order_status === 'new_order'">
                  <span class="label bg-primary-600"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'processed_order'">
                  <span class="label bg-indigo-600"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'canceled'">
                  <span class="label bg-orange-600"> {{ r.order_status }}</span>
                </td>
                <td v-if="r.order_status === 'refunded'">
                  <span class="label bg-danger-600"> {{ r.order_status }}</span>
                </td>
                <td v-if="r.order_status === 'approved_order'">
                  <span class="label bg-green-600"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'purchased'">
                  <span class="label bg-teal-400"> {{ r.order_status }}</span>
                </td>
                <td v-if="r.order_status === 'warehouse_delivered_order'">
                  <span class="label bg-purple-400">
                    {{ r.order_status.replace('_', ' ').replace('_order', '') }}</span>
                </td>
                <td v-if="r.order_status === 'int_shipment'">
                  <span class="label bg-info-400"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'branch_delivery'">
                  <span class="label bg-violet-600"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'delivered'">
                  <span class="label bg-warning-300"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'ship_only'">
                  <span class="label bg-blue-300"> {{ r.order_status.replace('_', ' ') }}</span>
                </td>
                <td v-if="r.order_status === 'archived'">
                  <span v-if="r.is_canceled == '1'">
                    <span class="label bg-orange-600">canceled</span>
                  </span>
                  <span v-if="r.is_refunded == '1'">
                    <span class="label bg-danger-600">refunded</span>
                  </span>
                  <span class="label bg-grey-600 mt-1">archived</span>
                </td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.warehouse_date }}</td>
                <td>{{ r.bank_name }}</td>
                <td>{{ r.item_price }}</td>
                <td>{{ r.actual_price }}</td>
                <td>{{ r.item_price * r.quantity + r.national_tax + r.delivery_price | usdFormat }}</td>
                <td>{{ r.total_amount }}</td>
                <td>{{ r.internal_shipping_handling }}</td>
                <td>{{ r.tax }}</td>
                <td>{{ r.kreenex_fee }}</td>
                <td>{{ r.quantity_charge }}</td>
                <td>{{ r.national_tax }}</td>
                <td>{{ r.insurance }}</td>
                <td>{{ r.delivery_price }}</td>
                <td>{{ r.discount }}</td>
                <td>{{ r.purchases_by_user }}</td>
                <td class="action-td">
                  <!-- style="position: sticky; right: 0" -->
                  <div
                    class="action-container"
                    style="display: flex"
                  >
                    <a
                      v-if="$_has_perm('view_order_detail')"
                      style="color: #01579b; padding: 0px 6px"
                      tooltip="View Details"
                      @click="initDetail('modal_showApp', r.order_id)"
                    >
                      <i class="material-icons">aspect_ratio</i>
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails
  },
  created() {
    this.getLoggedInUser()
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      // {
      //   label: 'Branches',
      //   text: 'Branches',
      //   value: '2',
      //   sortable: false,
      //   searchable: false,
      //   name: 'branches',
      // },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'order_id',
      },
      {
        label: 'Invoice No.',
        text: 'Invoice No.',
        value: '3',
        sortable: false,
        searchable: false,
        name: 'last_order_invoice'
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID',
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'customer_id_fk',
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'customer_note',
      },
      {
        label: 'Phone Number',
        text: 'Phone Number',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'phone_number',
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_url',
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'product_name',
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'quantity',
      },
      {
        label: 'Order Status',
        text: 'Order Status',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'order_status',
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'country',
      },
      {
        label: 'Type',
        text: 'Type',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'purchase_note',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: 'Purchase Date',
        text: 'Purchase Date',
        value: '17',
        sortable: true,
        searchable: false,
        name: 'purchase_date',
      },
      {
        label: 'Warehouse Date',
        text: 'Warehouse Date',
        value: '18',
        sortable: true,
        searchable: false,
        name: 'warehouse_date',
      },
      {
        label: 'Bank Name',
        text: 'Bank Name',
        value: '19',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
      {
        label: 'Item Price',
        text: 'Item Price',
        value: '20',
        sortable: true,
        searchable: true,
        name: 'item_price',
      },
      {
        label: 'Actual Cost',
        text: 'Actual Cost',
        value: '21',
        sortable: true,
        searchable: true,
        name: 'actual_price',
      },
      {
        label: 'Purchase Cost',
        text: 'Purchase Cost',
        value: '22',
        sortable: false,
        searchable: false,
        name: '',
      },
      {
        label: 'Total Amount',
        text: 'Total Amount',
        value: '23',
        sortable: true,
        searchable: true,
        name: 'total_amount',
      },
      {
        label: 'Shipment',
        text: 'Shipment',
        value: '24',
        sortable: true,
        searchable: true,
        name: 'internal_shipping_handling',
      },
      {
        label: 'Tax',
        text: 'Tax',
        value: '25',
        sortable: true,
        searchable: true,
        name: 'tax',
      },
      {
        label: 'Shipzone Fee',
        text: 'Shipzone Fee',
        value: '26',
        sortable: true,
        searchable: true,
        name: 'kreenex_fee',
      },
      {
        label: 'Quantity charge',
        text: 'Quantity charge',
        value: '27',
        sortable: true,
        searchable: true,
        name: 'quantity_charge',
      },
      {
        label: 'International Tax',
        text: 'International Tax',
        value: '28',
        sortable: true,
        searchable: true,
        name: 'national_tax',
      },
      {
        label: 'Insurance',
        text: 'Insurance',
        value: '29',
        sortable: true,
        searchable: true,
        name: 'insurance',
      },
      {
        label: 'Delivery Price',
        text: 'Delivery Price',
        value: '30',
        sortable: true,
        searchable: true,
        name: 'delivery_price',
      },
      {
        label: 'Discount',
        text: 'Discount',
        value: '31',
        sortable: true,
        searchable: true,
        name: 'discount',
      },
      {
        label: 'Purchased By',
        text: 'Purchased By',
        value: '32',
        sortable: true,
        searchable: true,
        name: 'purchases_by_user',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      url: 'api/purchase_history',
      orderDetailUrl: 'api/show_order_detail',
      qrCodeValues: [],
      loggedInUserData: {},
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      btnsave: true,
      orderData: 0,
      detialData: {
        the_tl_price: '',
        order_id: '',
        bank_name: '',
        discount: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        item_type: '',
        note: '',
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      theOrderTotalAmount: '',
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        wh_dt_passed: 0,
        branches_id: '',
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
    }
  },

  methods: {
    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'
      let loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      let warehouses = loggedInUserData.warehouse_id_fk
      let perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page
      if (
        searchValue !== '0' ||
        searchedOneCol !== '0' ||
        searchedOneVal !== '0' ||
        toDate !== '0' ||
        fromDate !== '0'
      ) {
        perPage = '0'
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      window.location.replace(
        fullHostName +
        '/api/purchase-history-export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate +
        '&warehouses=' +
        warehouses +
        '&per_page=' +
        perPage
      )
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    getRowStyle(data) {
      let today = new Date()
      let warehouseDate = new Date(data.warehouse_date)
      let next8Days = new Date(warehouseDate.getTime())
      next8Days.setDate(next8Days.getDate() + 8)

      if (next8Days < today) return 'background-color: #FFAB91'

      return ''
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.wh_dt_passed = '0'
      this.getResults()
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.wh_dt_passed = '0'
      this.getResults()
    },

    generateQrCode() {
      this.closeGenerateQrCodeModal()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() != '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },
  },
}
</script>

<style>
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.table-tr:hover .action-td {
  position: sticky;
  right: -2px;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/purchaseHistory.vue